import { isToolbarMenuActive } from './ToolbarStore';

export const updateToolbarMenu= (value) => isToolbarMenuActive.update((oldValue) => value);
